import React, { createContext, useMemo, useState, useRef, useEffect, useContext, useLayoutEffect } from 'react';
import { LightboxModal, LightboxContent, Image, ImageWrap, Close, Controls, Description } from './styles.js';

function parseRawImage(src) {
  return src.split(',').pop().trim().split(' ').shift().replace(/_s=\d+x_/, '_') || src;
}

export var LightboxContext = /*#__PURE__*/createContext();
export var SectionLightboxContext = /*#__PURE__*/createContext();
export function useLightbox(lightbox, _ref) {
  var src = _ref.src,
      srcSet = _ref.srcSet,
      description = _ref.description;
  var context = useContext(LightboxContext);
  var image = useMemo(function () {
    return {
      src: src,
      srcSet: srcSet,
      description: description
    };
  }, [src, srcSet, description]);
  useEffect(function () {
    if (lightbox) {
      return context.subscribe(image);
    }
  }, [context, image, lightbox]);

  if (lightbox) {
    return function () {
      return context.activate(image);
    };
  }
}
export function Lightbox(props) {
  var images = useRef([]);

  var _useState = useState(false),
      active = _useState[0],
      setActive = _useState[1];

  var _useState2 = useState(0),
      index = _useState2[0],
      setIndex = _useState2[1];

  var memo = useMemo(function () {
    function subscribe(image) {
      images.current.push(image);
      return function unsubscribe() {
        images.current = images.current.filter(function (i) {
          return i !== image;
        });
      };
    }

    function activate(image) {
      setActive(true);
      setIndex(images.current.findIndex(function (i) {
        return i === image;
      }));
    }

    return {
      subscribe: subscribe,
      activate: activate
    };
  }, []);
  useEffect(function () {
    if (!active) return;

    var onKeyUp = function onKeyUp(event) {
      switch (event.keyCode) {
        case 37:
          // left arrow
          return setIndex(function (i) {
            return (i - 1 + images.current.length) % images.current.length;
          });

        case 39:
          // right arrow
          return setIndex(function (i) {
            return (i + 1) % images.current.length;
          });

        case 27:
          // escape
          return setActive(false);
      }
    };

    window.addEventListener('keyup', onKeyUp);
    return function () {
      return window.removeEventListener('keyup', onKeyUp);
    };
  }, [active]);
  useLayoutEffect(function () {
    if (active) {
      document.body.style.overflow = 'hidden';
      return function () {
        document.body.style.overflow = null;
      };
    }
  }, [active]);
  return /*#__PURE__*/React.createElement(LightboxContext.Provider, {
    value: memo
  }, props.children, active ? /*#__PURE__*/React.createElement(LightboxModal, {
    onClick: function onClick() {
      return setActive(false);
    }
  }, /*#__PURE__*/React.createElement(Close, {
    onClick: function onClick() {
      return setActive(false);
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M19.676 2.738l-1.414-1.414L10.5 9.086 2.738 1.324 1.324 2.738 9.086 10.5l-7.762 7.762 1.414 1.414 7.762-7.762 7.762 7.762 1.414-1.414-7.762-7.762z"
  }))), /*#__PURE__*/React.createElement(LightboxContent, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement(ImageWrap, {
    key: index
  }, /*#__PURE__*/React.createElement(Image, {
    src: images.current[index].src,
    srcSet: images.current[index].srcSet,
    sizes: "100vw"
  })), /*#__PURE__*/React.createElement(Controls, null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setIndex(function (i) {
        return (i - 1 + images.current.length) % images.current.length;
      });
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M13.54 20.767L5.401 10.5 13.54.233l1.566 1.242L7.953 10.5l7.153 9.024z"
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setIndex(function (i) {
        return (i + 1) % images.current.length;
      });
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M7.46 20.767l-1.566-1.243 7.153-9.024-7.153-9.025L7.46.233 15.6 10.5z"
  })))))) : null);
}